// extracted by mini-css-extract-plugin
module.exports = {"tableRow":"tablas_tableRow__GoLj-"};